import React from "react";

export default function Table(props) {
  return <table className={`c-table ${props.className}`}>{props.children}</table>;
}
